import {Injectable, NgZone} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { WindowRef } from '../window-ref';
import { IpcChannelDataInterface } from './ipc-channel.data.interface';

@Injectable()
export class IpcChannelService {
	private _subject: Subject<IpcChannelDataInterface> = new Subject();

	public data$: Observable<IpcChannelDataInterface> = this._subject.asObservable();

	constructor(private _window: WindowRef, private _z: NgZone) {
		if (this._window.nativeWindow['ipc']) {
			this._window.nativeWindow['ipc'].on('actionchannel', (event, message) => {
				this._z.run(() => {
					this._subject.next(message);
				});
			});
		}
	}

	public publishEmulatedEvent(message: any) {
		this._subject.next(message);
	}

	public send(payload: any, channel: string = 'actionchannel') {
		if (this._window.nativeWindow['ipc']) {
			this._window.nativeWindow['ipc'].send(channel, payload);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ipc-channel/ipc-channel.service.ts